import api from "../../api/apiInterceptor";
import {store} from "../../redux-store/store";
import {reloadTableView} from "../../redux-store/globalData";
import {displayNotification} from "../../redux-store/notification";

export const sendCommand = async (deviceId, data, mapDrawer = false) => {

    const state = store.getState()

    let post_data = {
        deviceId: deviceId,
        methodName: data.methodName,
        arguments: data.arguments ? data.arguments : []
    }

    await api.post(`/api/installations/${state.globalData.installationSelect.value}/command`, post_data)
    if (mapDrawer) {
        store.dispatch(displayNotification({
            notificationStatus: "info",
            message: "Komanda poslata",
            title: "Komanda"
        }))
    } else {
        store.dispatch(reloadTableView())
    }
}